import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function RegisterWithUsername() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedUsername, setSelectedUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: session } = await supabase.auth.getSession();
      const userEmail = session?.session?.user?.email;
      if (!userEmail) return;

      const { data, error } = await supabase
        .from('creadores')
        .select('url')
        .eq('email', userEmail)
        .single();

      if (data?.url) {
        navigate(`/creador/${data.url}`);
      }
    };

    checkUser();
  }, []);

  const generateSuggestions = async () => {
    const parts = fullName.trim().toLowerCase().split(' ');
    if (parts.length < 2) return setError('Please enter your full name (first and last)');

    const [first, last] = parts;
    const options = [
      `${first[0]}${last}`,
      `${first[0]}${last.slice(0, 3)}`,
      `nubbimaster${first[0]}${last}`,
    ];
    const available = [];

    for (const option of options) {
      const { data } = await supabase
        .from('creadores')
        .select('url')
        .eq('url', option);
      if (data.length === 0) available.push(option);
    }

    setSuggestions(available);
    setStep(2);
  };

  const handleRegister = async () => {
    setLoading(true);
    setError(null);

    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      options: {
        emailRedirectTo: 'https://nubbiland.com'
      }
    });

    if (authError) {
      setError(authError.message);
      setLoading(false);
      return;
    }

    const { error: insertError } = await supabase.from('creadores').insert({
      nombre_compl: fullName,
      url: selectedUsername,
      email,
    });

    if (insertError) {
      setError('Error creating creator profile: ' + insertError.message);
    } else {
      setStep(3);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: '2rem auto', textAlign: 'center' }}>
      <h2>Create Your Nubbi Profile</h2>

      {step === 1 && (
        <>
          <input
            type="text"
            placeholder="Your full name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
          />
          <button onClick={generateSuggestions} style={{ padding: '0.75rem 1.5rem' }}>
            Suggest Usernames
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <p>Select a username:</p>
          {suggestions.map((s) => (
            <div key={s}>
              <input
                type="radio"
                name="username"
                value={s}
                onChange={(e) => setSelectedUsername(e.target.value)}
              />{' '}
              {s}
            </div>
          ))}
          {selectedUsername && (
            <>
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', padding: '0.5rem', marginTop: '1rem' }}
              />
              <br />
              <button onClick={handleRegister} style={{ marginTop: '1rem', padding: '0.75rem 1.5rem' }}>
                Register
              </button>
            </>
          )}
        </>
      )}

      {step === 3 && <p>Check your email to confirm and enter NubbiLand! 🎉</p>}

      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

